import { monsters } from '../monsters/monsters-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { IDialog } from '../uiParts/dialogs'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'

interface IStat {
  textLabel: IStevieText
  textValue: IStevieText
}

interface IData {
  isOpen: boolean
  texts: IStevieText[]
  stats: IStat[]
  statName: IStat
  statHp: IStat
  statThirst: IStat
  statHunger: IStat
  statEnergy: IStat
  statSocial: IStat
  statToilet: IStat
  statEntertainment: IStat
  statOxygen: IStat
  statSuitOxygen: IStat
  dialog: dialogs.IDialog
}
let _data: IData | null = null

export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()

    let x = 20
    let y = 100

    let dialog: IDialog = dialogs.create(10, 15, x, y, 'Stats', () => {
      setOpen(false)
    })

    y += 25

    let texts: IStevieText[] = []
    let stats: IStat[] = []
    let addStat = (label: string, isMonospace: boolean = true) => {
      y += 25

      let textLabel = stevieText.create(ctx.font24, x, y)
      stevieText.setText(textLabel, label)

      let textVal = stevieText.create(ctx.font24, x + 150, y)
      stevieText.setText(textVal, 'unknown')
      if (isMonospace) {
        stevieText.setMonospace(textVal, true)
      }
      let stat = {
        textLabel: textLabel,
        textValue: textVal,
      }
      stats.push(stat)
      texts.push(textLabel)
      texts.push(textVal)
      return stat
    }

    let statName = addStat('Name', false)
    let statHp = addStat('Health')
    let statThirst = addStat('Thirst')
    let statHunger = addStat('Hunger')
    let statToilet = addStat('Toilet')
    let statSocial = addStat('Social')
    let statEnergy = addStat('Energy')
    let statEntertainment = addStat('Joy')
    let statOxygen = addStat('Oxygen')
    let statSuitOxygen = addStat('Suit Oxy.')

    _data = {
      isOpen: false,
      texts,
      stats,
      statName,
      statThirst,
      statHunger,
      statEntertainment,
      statEnergy,
      statHp,
      statSocial,
      statToilet,
      statOxygen,
      statSuitOxygen,
      dialog,
    }
    setOpen(false)
  }
  return _data
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiStats', isOpen)

  let data = getData()
  dialogs.setVisible(data.dialog, isOpen)
  data.isOpen = isOpen

  l.forEach(data.texts, (c) => {
    stevieText.setVisible(c, isOpen)
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()

  let data = getData()
  if (data.isOpen) {
    let m = monsters.getAll()[0]

    let formatNumber = (s: number, max = 100) => {
      let v = '' + Math.round(s)

      return lpad(v) + '/' + lpad('' + max)
    }
    let lpad = (v: string, m = 3) => {
      while (v.length < 3) {
        v = ' ' + v
      }
      return v
    }

    stevieText.setText(data.statName.textValue, m.statName)
    stevieText.setText(
      data.statHp.textValue,
      formatNumber(m.hitPoints, m.maxHitPoints),
    )

    stevieText.setText(data.statThirst.textValue, formatNumber(m.statThirst))
    stevieText.setText(data.statHunger.textValue, formatNumber(m.statHunger))
    stevieText.setText(data.statToilet.textValue, formatNumber(m.statToilet))
    stevieText.setText(data.statEnergy.textValue, formatNumber(m.statEnergy))
    stevieText.setText(data.statSocial.textValue, formatNumber(m.statSocial))
    stevieText.setText(
      data.statEntertainment.textValue,
      formatNumber(m.statEntertainment),
    )
    stevieText.setText(data.statOxygen.textValue, formatNumber(m.statOxygen))
    stevieText.setText(
      data.statSuitOxygen.textValue,
      formatNumber(m.statSuitOxygen),
    )
    // let mode = tileMapEditor.getMode()
    // stevieText.setText(data.textMode, mode)
  }
}
